/**
 * Price-change hints on a накладная (SPEC §1): how far the current price moved
 * from the previous накладная's price. Percent with one decimal, Russian
 * comma, explicit sign; null when there is no previous price to compare with.
 */
export function formatDeltaPct(prevKopeks: number, curKopeks: number): string | null {
  if (prevKopeks <= 0) return null;
  const pct = ((curKopeks - prevKopeks) / prevKopeks) * 100;
  const rounded = Math.round(pct * 10) / 10;
  if (rounded === 0) return null;
  const sign = rounded > 0 ? '+' : '−';
  return `${sign}${String(Math.abs(rounded)).replace('.', ',')} %`;
}

/** True when both prices are known and differ. */
export function priceChanged(
  prevKopeks: number | null | undefined,
  curKopeks: number | null | undefined,
): boolean {
  return prevKopeks != null && curKopeks != null && prevKopeks !== curKopeks;
}
